export class SchoolLevel{
    id : number;
    schoolLevelCode : string;
    schoolLevelName : string; 
    type: number;
    displayOrder : number;
} 